const CARDS = [
  ["total", "Total sign-ups"],
  ["drivers", "Drivers"],
  ["customers", "Customers"],
  ["today", "Today (UTC)"],
  ["week", "Last 7 days"],
];

export const StatCards = ({ stats }) => (
  <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
    {CARDS.map(([k, label]) => (
      <div key={k} className={`rounded-2xl p-5 ring-1 ring-slate-200 ${k === "drivers" ? "bg-[#13296B] text-white ring-0" : "bg-white"}`} data-testid={`admin-stat-${k}`}>
        <p className={`text-xs font-mono uppercase tracking-[0.15em] ${k === "drivers" ? "text-slate-300" : "text-slate-500"}`}>{label}</p>
        <p className={`font-display text-4xl font-extrabold mt-2 ${k === "drivers" ? "" : "text-[#13296B]"}`}>{stats?.[k] ?? "–"}</p>
      </div>
    ))}
  </div>
);

export const VehicleBars = ({ vehicles }) => {
  const entries = Object.entries(vehicles);
  const max = Math.max(1, ...entries.map(([, n]) => n));
  return (
    <div className="rounded-2xl bg-white ring-1 ring-slate-200 p-6" data-testid="admin-vehicle-breakdown">
      <p className="font-display text-lg font-bold text-[#13296B] mb-4">Drivers by vehicle</p>
      <div className="space-y-3">
        {entries.map(([v, n]) => (
          <div key={v} className="grid grid-cols-[110px_1fr_40px] sm:grid-cols-[140px_1fr_40px] items-center gap-3 text-sm">
            <span className="text-slate-700 font-semibold">{v}</span>
            <div className="h-3 rounded-full bg-[#F0F5FD] overflow-hidden"><div className="h-full rounded-full bg-[#2F7FF0] transition-[width] duration-700" style={{ width: `${(n / max) * 100}%` }} /></div>
            <span className="text-right font-mono text-[#13296B]">{n}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
